const bundle = {
  close: () => 'Loka',
  error: () => 'Villa',
  warn: () => 'Viðvörun',
  info: () => 'Uppl.',
  confirmation: () => 'Staðfesting',
  progressIndeterminate: () => 'Í vinnslu',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Á milli ' + p['FROM_SECTION'] + ' og ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Enginn eins hluti fannst.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Veljið skrá til að velja gildi',
  indexer_touchInstructionText: () =>
    'Tvísmellið og haldið til að fara í strokham, dragið síðan upp og niður til að breyta gildi.',
  inputPassword_show: () => 'Sýna aðgangsorð',
  inputPassword_hide: () => 'Fela aðgangsorð',
  inputPassword_hidden: () => 'Aðgangsorð falið',
  formControl_clear: () => 'Hreinsa',
  formControl_loading: () => 'Hleður',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Farið framyfir ' + p['MAX_LENGTH'] + ' hámarkslengd.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tákn eftir.',
  select_noMatchesFound: () => 'Ekkert samsvarandi fannst.',
  select_oneMatchFound: () => 'Ein samsvörun fannst',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' samsvaranir fundust',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' eða fleiri samsvaranir fundust',
  selectMultiple_showSelectedValues: () => 'Sýna eingöngu valin gildi.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) => p['VALUE_COUNT'] + ' gildi valin.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Hakað í hakreit',
  selector_unselected: () => 'Ekki hakað í hakreit',
  userAssistance_learnMore: () => 'Nánar',
  userAssistance_required: () => 'Áskilið',
  filePicker_singleFileUploadError: () => 'Hlaðið einni skrá upp í einu',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ekki er hægt að hlaða upp skrám af tegundinni ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ekki er hægt að hlaða upp skrám af tegundinni ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'óþekkt',
  filePicker_dropzonePrimaryText: () => 'Draga og sleppa',
  filePicker_dropzoneSecondaryText: () => 'Veljið skrá eða sleppið skrá hér',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Veljið eða sleppið skrám hér',
  filePicker_addFiles: () => 'Bæta skrám við',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Auka',
  inputNumber_decrease: () => 'Minnka',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Ekkert til birtingar',
  message_navigationFromMessagesRegion: () =>
    'Skráningarsvæði skilaboða. Veljið F6 til að fara til baka í fyrri þátt.',
  message_navigationToMessagesRegion: () =>
    'Ný skilaboð eru á skilaboðasvæði. Veljið F6 til að fara í síðasta skilaboðasvæði.',
  messageToast_allMessagesClosed: () => 'Öllum skjáskilaboðum hefur verið lokað.'
};
export default bundle;
